const state = new Map();

export default function(imgSrc) {
    return new Promise(function(resolve, reject) {

        if(state.get(imgSrc) === 'loaded') {
            resolve();
            return;
        }

        state.set(imgSrc, 'loading');

        const hiddenImg = new Image();

        hiddenImg.onload = function() {
            state.set(imgSrc, 'loaded');
            resolve(imgSrc);
        };

        hiddenImg.onerror = function() {
            state.set(imgSrc, 'aborted');

            reject(imgSrc);
        }

        hiddenImg.src = imgSrc;
    });
}
